// extracted by mini-css-extract-plugin
export var avatarContainer = "_8k-0";
export var avatarTypingWave = "_8k-i";
export var gray = "_8k-f";
export var green = "_8k-c";
export var icon = "_8k-9";
export var image = "_8k-1";
export var lg = "_8k-6";
export var md = "_8k-5";
export var presenceDot = "_8k-b";
export var red = "_8k-d";
export var sm = "_8k-4";
export var status = "_8k-a";
export var typingDot = "_8k-h";
export var typingPill = "_8k-g";
export var xl = "_8k-7";
export var xs = "_8k-3";
export var xxl = "_8k-8";
export var xxs = "_8k-2";
export var yellow = "_8k-e";